// Cookie Consent Banner
// Displays cookie consent banner for first-time visitors or when expired (12 months)

const COOKIE_EXPIRY_DAYS = 365;

/**
 * Get cookie name from data attribute
 * @returns {string} cookie name from config
 */
function getCookieName() {
  const banner = document.getElementById('cookie-consent-banner');
  return banner?.dataset?.cookieName || 'web_consent';
}

/**
 * Initialize the cookie consent banner
 */
function initCookieConsent() {
  if (!hasConsent()) {
    showBanner();
  }
}

/**
 * Check if valid consent cookie exists
 * @returns {boolean} true if consent exists
 */
function hasConsent() {
  const cookieName = getCookieName();
  const value = window.Cookies ? window.Cookies.get(cookieName) : getCookieFallback(cookieName);
  return !!value;
}

/**
 * Fallback cookie getter
 */
function getCookieFallback(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length);
    }
  }
  return null;
}

/**
 * Show the cookie consent banner
 */
function showBanner() {
  const banner = document.getElementById('cookie-consent-banner');
  if (banner) {
    banner.classList.remove('hidden');
    banner.classList.add('flex');
  }
}

/**
 * Hide the cookie consent banner
 */
function hideBanner() {
  const banner = document.getElementById('cookie-consent-banner');
  if (banner) {
    banner.classList.add('hidden');
    banner.classList.remove('flex');
  }
}

/**
 * Accept cookies and store expiry timestamp (365 days from now)
 */
function acceptCookies() {
  const cookieName = getCookieName();
  const expirySeconds = 365 * 24 * 60 * 60;
  const expiryTimestamp = Math.floor(Date.now() / 1000) + expirySeconds;

  if (window.Cookies) {
    window.Cookies.set(cookieName, expiryTimestamp, {
      expires: COOKIE_EXPIRY_DAYS,
      path: '/',
      sameSite: 'Lax'
    });
  } else {
    const date = new Date();
    date.setTime(date.getTime() + (expirySeconds * 1000));
    document.cookie = cookieName + "=" + expiryTimestamp +
                      "; expires=" + date.toUTCString() +
                      "; path=/; SameSite=Lax";
  }

  hideBanner();
}

window.acceptCookies = acceptCookies;
window.initCookieConsent = initCookieConsent;

document.addEventListener('DOMContentLoaded', initCookieConsent);
